// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".advisory[data-v-fad11a94]{display:flex;flex-direction:column;gap:20px;margin-bottom:20px}.advisory .advisory__section[data-v-fad11a94]{min-width:250px}.advisory .advisor__text[data-v-fad11a94]{font-weight:400}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
